module.exports = __webpack_public_path__ + "static/picture4-6e1edecb2afac169b07fa235e9323bee.png";